import React, {useCallback, useMemo} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {getPrivateProfileRecommendationStart} from "features/pages/single-people/reducer";
import {privateProfileRecommendationData} from "features/pages/single-people/selectors";
import Title from "features/components/title";
import {__} from "services/i18n";
import Button from "features/components/button";
import {recommendationRequestReset, recommendationRequestStart} from "store/reducer/recommendation/request/reducer";
import {
    recommendationRequestErrorSelector,
    recommendationRequestLoadingSelector, recommendationRequestSuccessSelector
} from "store/reducer/recommendation/request/selectors";
import {sendMessageSetShow} from "features/modals/send-message/reducer";
import {sendRecommendationSetShow} from "features/modals/send-recommendation/reducer";
import {sendRecommendationShowModal} from "features/modals/send-recommendation/selectors";
import SendRecommendationModal from "features/modals/send-recommendation";
import {ignoreRecommendationRequestLoadingSelector} from "store/reducer/recommendation/ignore_request/selectors";
import {ignoreRecommendationRequestStart} from "store/reducer/recommendation/ignore_request/reducer";
import Text from "features/components/text";
import {ISO_8601} from "moment";
import moment from "moment";
import {withToastManager} from "react-toast-notifications";

/* istanbul ignore next */
const mapStateToProps = state => ({
    data: privateProfileRecommendationData(state),
    request_loading: recommendationRequestLoadingSelector(state),
    request_error: recommendationRequestErrorSelector(state),
    request_success: recommendationRequestSuccessSelector(state),
    show_recommendation_modal: sendRecommendationShowModal(state),
    ignore: {
        loading: ignoreRecommendationRequestLoadingSelector(state)
    }
});
/* istanbul ignore next */
const mapDispatchToProps = {
    getPrivateProfileRecommendationStart,
    recommendationRequestStart,
    sendMessageSetShow,
    sendRecommendationSetShow,
    ignoreRecommendationRequestStart,
    recommendationRequestReset
};


export const PrivateProfileRecommendation = (props) => {
    const {slug, data, request_loading, user_id, name, show_recommendation_modal, ignore, request_success} = props;
    const {getPrivateProfileRecommendationStart, recommendationRequestStart, sendMessageSetShow, sendRecommendationSetShow, ignoreRecommendationRequestStart, recommendationRequestReset} = props;

    const {recommendation_enabled, request_sent, request_received, recommendation_sent, recommendation_received} = data;

    React.useEffect(() => {
        getPrivateProfileRecommendationStart({slug});
    }, [getPrivateProfileRecommendationStart, slug])

    React.useEffect(() => {
        if(!request_success) return;
        props.toastManager.add(__("recommendation_box.request_success"), { appearance: "success", id: "recommendation-request-success" });
        recommendationRequestReset()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request_success, recommendationRequestReset]);


    const openSendMessageModal = useCallback(() => {
        sendMessageSetShow({show: true, id: user_id, name: name});
    }, [name, sendMessageSetShow, user_id]);

    const requestRecommendation = useCallback(() => {
        recommendationRequestStart({id: user_id})
    }, [recommendationRequestStart, user_id]);

    const whatYouCanDo = useMemo(() => {
        return <div className="white-box">
            <Title size={20} align={"center"}>{__("recommendation_box.what_you_can_do")}</Title>
            <Button title={__("recommendation_box.send_message")} onClick={openSendMessageModal} icon={"email"} />
            {!request_sent && <Button title={__("recommendation_box.request")} onClick={requestRecommendation} status={request_loading ? "loading" : null} icon={"star"} type={"outlined"} /> }
        </div>
    }, [openSendMessageModal, requestRecommendation, request_sent, request_loading]);

    const openSendRecommendationModal = useCallback(() => {
        if(!request_received) {
            return null;
        }
        sendRecommendationSetShow({show: true, id: request_received.id, name: name});
    }, [request_received, sendRecommendationSetShow, name]);

    const ignoreRecommendationRequest = useCallback(() => {
        ignoreRecommendationRequestStart({id: request_received.id});
    }, [ignoreRecommendationRequestStart, request_received]);

    const showRecommendation = useCallback(({title, content, date}) => {
        return <div className={"recommendation white-box"}>
            <Title size={20} align={"center"}>{title}</Title>
            <div className={"white-box"}>
                <Text size={16}>{content}</Text>
                <Text size={14} color={"light"} align={"center"}>{moment(date, ISO_8601).format("MMMM YYYY")}</Text>
            </div>
        </div>
    }, []);

    const recommendationRequested = useMemo(() => {
        if (!request_received) return null;
        return <div className="white-box yellow">
            <Title size={20} align={"center"}>{__("recommendation_box.recommendation_requested", [{key: "[name]", value: name}])}</Title>
            <Button title={__("recommendation_box.write")} onClick={openSendRecommendationModal} icon={"arrow-right"} />
            <Button title={__("recommendation_box.ignore")} onClick={ignoreRecommendationRequest} status={ignore.loading ? "loading" : null} icon={"delete"} type={"outlined"} />
        </div>
    }, [request_received, name, openSendRecommendationModal, ignoreRecommendationRequest, ignore.loading]);

    if(!recommendation_enabled) return null;
    return <div className={"recommendation_box"}>
        {recommendationRequested}
        {!!recommendation_received && showRecommendation({title: __("recommendation_box.recommendation_received", [{key: "[name]", value: name}]), content: recommendation_received.content, date: recommendation_received.created_at})}
        {!!recommendation_sent && showRecommendation({title: __("recommendation_box.recommendation_sent", [{key: "[name]", value: name}]), content: recommendation_sent.content, date: recommendation_sent.created_at})}
        {whatYouCanDo}
        {!!show_recommendation_modal && <SendRecommendationModal />}
    </div>;
};

export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(PrivateProfileRecommendation));